import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link } from 'react-router-dom';
import { ReactComponent as ModalIcon } from '../../images/Icons/happycoins_won.svg';

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
}));

export default function StoreContainer(props) {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.grow}>
                <AppBar position="static">
                    <Toolbar>
                        <Link to="/">
                            <IconButton
                                edge="start"
                                className={classes.menuButton}
                                color="inherit"
                                aria-label="back">
                                <ArrowBackIcon />
                            </IconButton>
                        </Link>
                        <Typography className="titleHeader" variant="h6" noWrap>
                            {props.translateFunc("STORE_LABEL")}
                        </Typography>
                        <div className={classes.grow} />
                    </Toolbar>
                </AppBar>
            </div>
            <div className="tempContent">
                <div>
                    <span><ModalIcon /></span>
                    <div className="title">{props.translateFunc("STORE_SECONDARY_TITLE")}</div>
                    <div className="text">{props.translateFunc("STORE_DESCRIPTION")}</div>
                    <div className="soon">{props.translateFunc("STORE_ITEMS_COMING_SOON")}</div>
                </div>
            </div>
        </div>
    );
}